require('./bootstrap');
require('./components/datatables.min');
require('./components/dataTables.bootstrap4.min');
//require('./components/summernote')
require('./components/main');
require('./components/info');
require('./components/other');
require('./components/swal')
require('./components/custom')
require('./components/select2')
require('./components/admin')
//const Chart = require('chart.js');
// require('inputmask');
// require('toastr');
